import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemInfo } from '../interface/system-info';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class SysInfoService {
  constructor(private api: ApiService) {}

  getInfo(): Observable<SystemInfo> {
    return this.api.all('sys_info').get<SystemInfo>();
  }
}
